import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
import { SafeHtml } from '@shared/ui';
import CdnImage from '../../../../CdnImage';

interface Props {
	className?: string;
	seatClassName?: string;
	customTitle?: React.ReactNode;
	dataColorNum?: string;
	title?: string;
	description?: string;
	image?: string;
}

// TODO: по факту это обвязка для любого места ( см SeatsInfoByPrice )
const FreeSeatInfo: React.FC<Props> = ({
	className,
	seatClassName,
	customTitle,
	dataColorNum,
	title,
	description,
	image
}) => {
	const { SeatsInfoStyles: theme } = useTheme('SeatMap');
	const { t } = useTranslation('SeatMap');

	return (
		<div className={cn(theme.freeSeat__container, className)}>
			<div className={theme.header}>
				<span data-color-num={dataColorNum} className={cn(theme.freeSeat__seat, seatClassName)}></span>
				<span className={theme.freeSeat__title}>{customTitle ?? t('Free seats')}</span>
			</div>

			{image && <CdnImage className={theme.image} path={image} alt={title} />}

			{(title || description) && (
				<div className={theme.seat__info}>
					{title && <SafeHtml tag="span" className={theme.title} html={title} />}
					{description && <SafeHtml tag="span" className={theme.description} html={description} />}
				</div>
			)}
		</div>
	);
};

export default FreeSeatInfo;
